(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/collections/all-odds-collection.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/collections/all-odds-collection.js');

(function(Backbone, _, svs) {
  'use strict';

  var log = new svs.core.log.Logger('svs.matchen.collections.AllOdds');

  svs.matchen.collections.AllOdds = Backbone.Collection.extend({
    url: function() {
      return (
        svs.core.jupiter.url() +
        '/draw/1/matchen/draws/' +
        this.drawNumber +
        '/oddslist'
      );
    },
    sortByAsc: false,
    initialize: function(data, options) {
      this.drawNumber = options.drawNumber;
      this.fetch({
        reset: true
      });
    },
    parse: function(data) {
      if (!data.oddslist || data.error) {
        log.error('Error parsing matchen odds', data.error || data);
        return [];
      }
      var result = [];
      var self = this;
      var index = 0;

      _.each(data.oddslist, function(res) {
        if (_.isArray(res)) {
          var sorted = _.sortBy(res, function(val) {
            return parseInt(val.odds, 10);
          });
          var header = 'Hemma';
          if (index !== 0 && index < 3) {
            header = index === 1 ? 'Oavgjorda' : 'Borta';
          } else if (index >= 3) {
            header = '-';
          }

          result.push({
            isAll: true,
            results: self.sortByAsc ? sorted : sorted.reverse(),
            header: header
          });
          index++;
        }
      });
      return result;
    },

    sortAllLists: function() {
      _.each(this.models, function(item) {
        item.set('results', item.get('results').reverse());
        return item;
      });
      if (this.models) {
        this.trigger('allOddsSorted', this.models);
      }
    }
  });
})(Backbone, _, svs);


 })(window);